<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template> -->
      </Table>
    </div>
  </div>
</template>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目编号",
          key: "projectId",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "班组所在企业统一社会信用代码",
          key: "corpCode",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "班组所在企业名称",
          key: "corpName",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "班组名称",
          key: "teamName",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "责任人姓名",
          key: "responsiblePersonName",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "责任人联系电话",
          key: "responsiblePersonPhone",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "责任人证件类型",
          key: "responsiblePersonIDCardType",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "责任人证件号码",
          key: "responsiblePersonIDNumber",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "备注",
          key: "remark",
          align: "center",
          minWidth: 210,
          tooltip: true,
        },
        { title: "进场日期", key: "entryTime", minWidth: 180, tooltip: true },
        {
          title: "退场日期",
          key: "exitTime",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "进场附件",
          key: "entryAttachments",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "退场附件",
          key: "exitAttachments",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "数据来源",
          key: "sourceAreaCode",
          align: "center",
          minWidth: 140,
          tooltip: true,
        },
      ],
    };
  },
};
</script>
